import React from 'react';

const Highlight = ({ header, content, center, reverse }) => {
  return (
    <div
      className="highlightWrapper"
      style={{ flexDirection: `${reverse ? 'row-reverse' : 'row'}` }}
    >
      <p>{header}</p>
      <div className="highlight" style={{ margin: `${center ? 'auto' : ''}` }}>
        {content}
      </div>
    </div>
  );
};

export default Highlight;
